import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentOrganization } from '~/queries/organization';
import useSelector from './useSelector';

/**
 * Returns a callback that redirects user to billing view and creates an analytics event
 * @param source - upsell source identifier passed to analytics event
 */
const useUpgrade = (source: string) => {
  const navigate = useNavigate();
  const { data: currentOrganization } = useCurrentOrganization();
  const currentUserCanManageBilling = useSelector(
    (state) => state.userResources.users.current.limit_overrides?.canManageBilling,
  );

  const canManageBilling =
    (currentUserCanManageBilling && currentOrganization?.permissions?.includes('manage_billing')) ??
    false;
  const shortName = currentOrganization?.short_name;

  const onUpgrade = useCallback(() => {
    if (shortName) {
      void navigate(`/${shortName}/settings/billing`);
    }
  }, [navigate, shortName, source]);

  return { onUpgrade, canManageBilling };
};

export default useUpgrade;
